<svelte:options customElement={{
  tag: 'page-title',
  shadow: 'none',
  props: {
    variant: { reflect: true, type: 'String' },
    text: { reflect: true, type: 'String' },
    subtitle: { reflect: true, type: 'String' },
    src: { reflect: true, type: 'String' },
    srcSp: { reflect: true, type: 'String' },
    alt: { reflect: true, type: 'String' },
    date: { reflect: true, type: 'String' },
    tags: { reflect: true, type: 'String' },
    hashtags: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * H1 ページタイトル
   * 3つのバリアントに対応するページヘッダーコンポーネント
   * @prop {string} variant - 'image' | 'simple' | 'detail' (default: 'simple')
   * @prop {string} text - タイトルテキスト
   * @prop {string} subtitle - サブタイトル（任意）
   * @prop {string} src - 背景画像URL（image variant のみ）
   * @prop {string} srcSp - 背景画像URL（image variant のみ、SP用）
   * @prop {string} alt - 画像alt（image variant のみ）
   * @prop {string} date - 日付（detail variant のみ）
   * @prop {string} tags - カテゴリタグJSON配列（detail variant のみ）
   * @prop {string} hashtags - ハッシュタグJSON配列（detail variant のみ）
   */
  export let variant = 'simple';
  export let text = '';
  export let subtitle = '';
  export let src = '';
  export let srcSp = '';
  export let alt = '';
  export let date = '';
  export let tags = '[]';
  export let hashtags = '[]';

  let parsedTags = [];
  let parsedHashtags = [];

  $: {
    try {
      parsedTags = typeof tags === 'string' ? JSON.parse(tags) : (Array.isArray(tags) ? tags : []);
    } catch (e) {
      console.warn('PageTitle: Invalid tags JSON', e);
      parsedTags = [];
    }
  }

  $: {
    try {
      parsedHashtags = typeof hashtags === 'string' ? JSON.parse(hashtags) : (Array.isArray(hashtags) ? hashtags : []);
    } catch (e) {
      console.warn('PageTitle: Invalid hashtags JSON', e);
      parsedHashtags = [];
    }
  }

  $: hasTags = parsedTags.length > 0;
  $: hasHashtags = parsedHashtags.length > 0;
</script>

{#if variant === 'image'}
  <div class="mod-pageTitle _image">
    <div class="mod-pageTitle-bg">
      <img src={src} alt={alt || ''} class="mod-pageTitle-bg_pc" />
      {#if srcSp}
      <img src={srcSp} alt={alt || ''} class="mod-pageTitle-bg_sp" />
      {/if}
      <div class="mod-pageTitle-overlay"></div>
    </div>
    <div class="mod-pageTitle-inner">
      <h1 class="mod-pageTitle-heading">{@html text}</h1>
      {#if subtitle}
        <p class="mod-pageTitle-subtitle">{@html subtitle}</p>
      {/if}
    </div>
  </div>
{:else if variant === 'detail'}
  <div class="mod-pageTitle _detail">
    <div class="mod-pageTitle-inner">
      <h1 class="mod-pageTitle-heading">{@html text}</h1>
      {#if subtitle}
        <p class="mod-pageTitle-subtitle">{@html subtitle}</p>
      {/if}
      {#if hasTags || date}
        <div class="mod-pageTitle-meta">
          {#if hasTags}
            <div class="mod-pageTitle-tags">
              {#each parsedTags as tag}
                <span class="mod-label _{tag.variant || 'type3'}">{tag.label}</span>
              {/each}
            </div>
          {/if}
          {#if date}
            <span class="mod-pageTitle-date">{date}</span>
          {/if}
        </div>
      {/if}
      {#if hasHashtags}
        <div class="mod-hashtag">
          {#each parsedHashtags as hashtag}
            <span class="mod-hashtag__item">
              {#if hashtag.href}
                <a href={hashtag.href}>{hashtag.label}</a>
              {:else}
                {hashtag.label}
              {/if}
            </span>
          {/each}
        </div>
      {/if}
    </div>
  </div>
{:else}
  <div class="mod-pageTitle _simple">
    <div class="mod-pageTitle-inner">
      <h1 class="mod-pageTitle-heading">{@html text}</h1>
      {#if subtitle}
        <p class="mod-pageTitle-subtitle">{@html subtitle}</p>
      {/if}
    </div>
  </div>
{/if}
